$('#frmLogin').submit(function(event) {
    event.preventDefault();
    $.ajax({
        url: '/',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'POST',
        data: $(this).serialize(),
        statusCode: {
            200: function() {
                Swal.fire({
                    type: 'success',
                    text: 'Login ok.'
                })
            },
            201: function() {
                console.log("TESTE 201");
            },
            203: function() {
                console.log("TESTE 203");
            },
            204: function() {
                console.log("TESTE 204");
            },
            404: function() {
                console.log("TESTE 404");
            },
            302: function() {

            },
        }
    });
});